import React, { useState } from 'react';
import { CalendarIcon, FilterXIcon, TableIcon, TrophyIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import RankingsTable from './RankingsTable';
const MatchesTable = () => {
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState<'calendar' | 'table'>('calendar');
  const [filters, setFilters] = useState({
    league: '',
    season: '',
    phase: '',
    date: '',
    team: ''
  });
  const [currentRound, setCurrentRound] = useState('1');
  const leagues = ['NBA', 'Euroleague', 'Liga ACB', 'LNB Pro A'];
  const seasons = ['2023-2024', '2022-2023', '2021-2022'];
  const phases = ['Regular Season', 'Playoffs', 'Play-In'];
  const teams = ['New York Knicks', 'Los Angeles Lakers', 'Boston Celtics'];
  const rounds = Array.from({
    length: 82
  }, (_, i) => (i + 1).toString());
  const matches = [{
    id: 1,
    homeTeam: {
      name: 'New York Knicks',
      logo: 'https://content.sportslogos.net/logos/6/216/thumbs/2nn48xofg0hms8k326cqdmuis.gif'
    },
    awayTeam: {
      name: 'Los Angeles Lakers',
      logo: 'https://content.sportslogos.net/logos/6/237/thumbs/uig7aiht8jnpl1szbi57zzlsh.gif'
    },
    score: {
      home: 112,
      away: 108,
      status: 'Final'
    },
    datetime: '2024-03-15 19:30',
    venue: 'Madison Square Garden',
    league: 'NBA',
    phase: 'Regular Season'
  }, {
    id: 2,
    homeTeam: {
      name: 'Boston Celtics',
      logo: 'https://content.sportslogos.net/logos/6/213/thumbs/slhg02hbef3j1ov4lsnwyol5o.gif'
    },
    awayTeam: {
      name: 'Miami Heat',
      logo: 'https://content.sportslogos.net/logos/6/214/thumbs/burm5gh2wvjti3xhei5h16k8e.gif'
    },
    score: {
      status: 'Scheduled',
      time: '20:00'
    },
    datetime: '2024-03-20 20:00',
    venue: 'TD Garden',
    league: 'NBA',
    phase: 'Regular Season'
  }];
  const resetFilters = () => {
    setFilters({
      league: '',
      season: '',
      phase: '',
      date: '',
      team: ''
    });
  };
  const handleMatchClick = (matchId: number) => {
    navigate(`/matches/${matchId}`);
  };
  return <div className="w-full max-w-7xl mx-auto pb-12" data-id="element-206" data-mp="26ue448vwyhuc">
      <div className="bg-white rounded-lg shadow-sm p-4 mb-6" data-id="element-207" data-mp="26tm6ytmo4c1y">
        <h2 className="text-xl font-bold mb-4" data-id="element-208" data-mp="2bnqh1lr8d079">Matches</h2>
        <div className="flex items-center gap-4" data-id="element-209" data-mp="2glrxs016onfk">
          <select value={filters.league} onChange={e => setFilters({
          ...filters,
          league: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-210" data-mp="2gkz1xu3rjic7">
            <option value="" data-id="element-211" data-mp="2ujqdb8r8qpwn">League</option>
            {leagues.map(league => <option key={league} value={league} data-id="element-212" data-mp="v8yz62rpnbc7">
                {league}
              </option>)}
          </select>
          <select value={filters.season} onChange={e => setFilters({
          ...filters,
          season: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-213" data-mp="1078vwht32jzx">
            <option value="" data-id="element-214" data-mp="iyg2vgp1iney">Season</option>
            {seasons.map(season => <option key={season} value={season} data-id="element-215" data-mp="dzmm9fegigak">
                {season}
              </option>)}
          </select>
          <select value={filters.phase} onChange={e => setFilters({
          ...filters,
          phase: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-216" data-mp="1blka7sblvdtw">
            <option value="" data-id="element-217" data-mp="xlsp77mo8x6e">Phase</option>
            {phases.map(phase => <option key={phase} value={phase} data-id="element-218" data-mp="3men3fec5s4ji">
                {phase}
              </option>)}
          </select>
          <input type="date" value={filters.date} onChange={e => setFilters({
          ...filters,
          date: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-219" data-mp="3ib8cvtqlg5rt" />
          <select value={filters.team} onChange={e => setFilters({
          ...filters,
          team: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-220" data-mp="107ibu4np9ulk">
            <option value="" data-id="element-221" data-mp="1xtxrd0wkgi6h">Team</option>
            {teams.map(team => <option key={team} value={team} data-id="element-222" data-mp="1ju6hncd31nya">
                {team}
              </option>)}
          </select>
          <button onClick={resetFilters} className="ml-auto flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900" data-id="element-223" data-mp="1nugr4z032whw">
            <FilterXIcon className="w-4 h-4 mr-2" data-id="element-224" data-mp="cgusmn8c3ijp" />
            Reset Filters
          </button>
        </div>
      </div>
      <div className="bg-white rounded-t-lg shadow-sm border-b sticky top-0" data-id="element-225" data-mp="4vsmc6f0odzu">
        <div className="p-4 flex items-center justify-between" data-id="element-226" data-mp="3w3mx1ab6grjz">
          <select value={currentRound} onChange={e => setCurrentRound(e.target.value)} className="rounded-md border-gray-300 text-sm min-w-[150px]" data-id="element-227" data-mp="3g5k8hryuk">
            {rounds.map(round => <option key={round} value={round} data-id="element-228" data-mp="3iax9v2jwxgla">
                Round {round}
              </option>)}
          </select>
          <div className="bg-gray-100 rounded-lg p-1" data-id="element-229" data-mp="3de6vcjnrat1z">
            <button onClick={() => setViewMode('calendar')} className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${viewMode === 'calendar' ? 'bg-white shadow text-blue-600' : 'text-gray-600'}`} data-id="element-230" data-mp="3s21p83di33gn">
              <CalendarIcon className="w-4 h-4" data-id="element-231" data-mp="2zj4gh70xltd1" />
            </button>
            <button onClick={() => setViewMode('table')} className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${viewMode === 'table' ? 'bg-white shadow text-blue-600' : 'text-gray-600'}`} data-id="element-232" data-mp="2ulcnsasgq37s">
              <TableIcon className="w-4 h-4" data-id="element-233" data-mp="3t2lcv5i4lcax" />
            </button>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-b-lg shadow-sm" data-id="element-234" data-mp="1w0su5qhn4ne">
        {viewMode === 'calendar' ? <table className="min-w-full" data-id="element-235" data-mp="31bfcqp2eneln">
            <tbody className="divide-y divide-gray-200" data-id="element-236" data-mp="31cqobb23dqnb">
              {matches.map(match => <tr key={match.id} className="hover:bg-gray-50" data-id="element-237" data-mp="35dsdt067ioc3">
                  <td className="py-4 px-6" data-id="element-238" data-mp="3abkherg7ryw4">
                    <div className="flex items-center justify-end gap-3" data-id="element-239" data-mp="3aaivtt1knu05">
                      <span className="font-medium" data-id="element-240" data-mp="3fc85b495bzm4">{match.homeTeam.name}</span>
                      <img src={match.homeTeam.logo} alt={match.homeTeam.name} className="w-8 h-8 object-contain" data-id="element-241" data-mp="pmebx6r3ht5u" />
                    </div>
                  </td>
                  <td className="py-4 px-6 w-32" data-id="element-242" data-mp="2f531ye2ggn3z">
                    <div className="flex items-center justify-center" data-id="element-243" data-mp="2a3nigqfxeonp">
                      {match.score.status === 'Final' ? <div className="text-center" data-id="element-244" data-mp="25bm9bde21e1w">
                          <div className="font-bold" data-id="element-245" data-mp="20enfyx27tb4r">
                            {match.score.home} - {match.score.away}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-246" data-mp="1wdtpbvxe1i86">Final</div>
                        </div> : <div className="text-center" data-id="element-247" data-mp="1me2vzxkkd99o">
                          <div className="font-medium" data-id="element-248" data-mp="1meuqf52fd0yd">{match.score.time}</div>
                          <div className="text-xs text-gray-500" data-id="element-249" data-mp="1hgb2x086nh3w">Scheduled</div>
                        </div>}
                    </div>
                  </td>
                  <td className="py-4 px-6" data-id="element-250" data-mp="3bsr5nr1rsd40">
                    <div className="flex items-center gap-3" data-id="element-251" data-mp="3bu2a7t31how6">
                      <img src={match.awayTeam.logo} alt={match.awayTeam.name} className="w-8 h-8 object-contain" data-id="element-252" data-mp="2knnap9p6y5fi" />
                      <span className="font-medium" data-id="element-253" data-mp="2butpywqz6du9">{match.awayTeam.name}</span>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500" data-id="element-254" data-mp="2fvdj7p8fgxb4">
                    <div data-id="element-255" data-mp="21wdvqkwniogj">{new Date(match.datetime).toLocaleDateString()}</div>
                    <div data-id="element-256" data-mp="26x1p3d8crhdx">{match.venue}</div>
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-500" data-id="element-257" data-mp="26u5plkguwknd">
                    <div className="flex items-center gap-1" data-id="element-258" data-mp="1sybovoq8l1lc">
                      <TrophyIcon className="w-4 h-4" data-id="element-259" data-mp="1wxsx2px1scu7" />
                      <span data-id="element-260" data-mp="1x0f3gm87cmau">{match.league}</span>
                    </div>
                    <div className="text-xs" data-id="element-261" data-mp="3nc355732mjpr">{match.phase}</div>
                  </td>
                  <td className="py-4 px-6" data-id="element-262" data-mp="3rbc2elxbkzq2">
                    <button onClick={() => handleMatchClick(match.id)} className="px-3 py-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md" data-id="element-263" data-mp="3ra0ymm3vjryy">
                      View Details
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table> : <RankingsTable data-id="element-264" data-mp="1zczhx8iv83iv" />}
      </div>
    </div>;
};
export default MatchesTable;